module.exports = __webpack_public_path__ + "static/media/aws_logo.c158a2e0.png";